<template>
    <div class="checkList-container">
        <div class="content">
            <div class="title">订阅来源</div>
            <p @click="emit(0)" class="close"></p>
            <div class="switch">
                <span>消息提醒</span>
                <div @click="isSwitch = !isSwitch" :class="{un: isSwitch}">
                  <i></i>
                </div>
            </div>
            <div class="input">
                <input v-model="keyWord" @keydown.enter="search" maxlength="100" placeholder="请输入要查询的来源" type="text">
                <i @click="search" class="search"></i>
            </div>
            <div class="list">
                <ul>
                    <li v-for="item in list" :key="item.client_id">
                        <div class="mainTitle">
                            <div class="left">
                                <i v-if="item.list.length > 0" class="on"></i>
                                <span>{{item.client_name}}<em v-if="item.list.length > 0">（{{item.list.length}}）</em></span>
                            </div>
                            <div @click="pSelect(item)" :class="{right: true, select: !item.selectAll && item.selected, all: item.selectAll && item.selected}"></div>
                        </div>
                        <ul v-if="item.list.length > 0">
                            <li v-for="items in item.list" :key="items.client_id">
                                <span>{{items.client_name}}</span>
                                <i @click="cSelect(item,items)" :class="{all: items.selected}"></i>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="btns">
                <p class="tips">
                    <i @click="selectAll" :class="{selectAll: true,on: isAll}"></i>已选{{selectNum}}项 <span>(最多{{total}}项)</span>
                </p>
                <div class="btn">
                    <p @click="emit(1)">确定</p>
                    <p @click="emit(0)">取消</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array
        },
        need_push: {
            type: [Number,String]
        }
    },
    data(){
        return {
            isSwitch: false,
            keyWord: null,
            timeout: null,
            selectNum: 0,
            total: 0,
            isAll: false
        }
    },
    watch: {
        list: {
            deep: true,
            handler: function(n, o) {
                let total = 0
                let selectNum = 0

                this.list.forEach(el => {
                    if(el.list.length > 0){
                        el.list.forEach(item => {
                            if(item.selected){
                                selectNum += 1
                            }
                        })
                        total += el.list.length
                    }else{
                        if(el.selected){
                            selectNum += 1
                        }
                        total += 1
                    }
                });
                
                this.selectNum = selectNum
                this.total = total
            }
        },
        need_push(to) {
            if(to == 1){
                this.isSwitch = false
            }else{
                this.isSwitch = true
            }
        }
    },
    methods: {
        selectAll() {
            this.isAll = !this.isAll
            if(this.isAll){
                this.list.forEach(el => {
                    el.selected = true
                })
            }else{
                this.list.forEach(el => {
                    el.selected = false
                })
            }
        },
        debounce(func, wait) {
            if (this.timeout) clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                func()
            }, wait)
        },
        search() {
            this.$emit('search', this.keyWord)
        },
        emit(type) {
            if(type-0 === 0){
                this.$emit('submit',type)
            }else{
                let list = []
                this.list.forEach(el => {
                    if(el.selected && el.selectAll){
                        list.push(el.client_id)
                    }else if(el.selected && !el.selectAll){
                        el.list.forEach(els => {
                            if(els.selected){
                                list.push(els.client_id)
                            }
                        })
                    }
                })
                list = list.join(',')
                this.$emit('submit',type,list,this.isSwitch)
            }
        },
        pSelect(item) {
            item.selected = !item.selected
            if(item.selected){
                item.selectAll = true
                if(item.list.length > 0){
                    item.selected = true
                }
            }else{
                item.selectAll = false
                if(item.list.length > 0){
                    item.selected = false
                }
            }

            let length = this.list.length
            let num = 0

            this.list.forEach(el => {
                if(el.selected){
                    num ++
                }
            })

            if(num === length){
                this.isAll = true
            }else if(num === 0){
                this.isAll = false
            }else{
                this.isAll = false
            }
        },
        cSelect(item, items) {
            items = !items
            let length = el.list.length
            let num = 0

            for (let index = 0; index < length; index++) {
                if(item[index].selected){
                    num ++
                }
            }

            if(num === length){
                item.selectAll = true
                this.isAll = true
            }else if(num === 0){
                item.selected = false
                item.selectAll = false
                this.isAll = false
            }else{
                item.selectAll = false
                this.isAll = false
            }
        }
    },
    mounted() {
        let total = 0
        let selectNum = 0
        let length = this.list.length
        let num = 0

        this.list.forEach(el => {
            if(el.selected){
                num ++
            }

            if(length == num){
                this.isAll = true
            }else{
                this.isAll = false
            }
            if(el.list.length > 0){
                el.list.forEach(item => {
                    if(item.selected){
                        selectNum += 1
                    }
                })
                total += el.list.length
            }else{
                if(el.selected){
                    selectNum += 1
                }
                total += 1
            }
        });
        if(this.need_push == 1){
            this.isSwitch = false;
        }else{
            this.isSwitch = true;
        }
        this.selectNum = selectNum
        this.total = total
    }
}
</script>

<style scoped lang="less">
    .checkList-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9;
        background: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -240px;
            margin-top: -280px;
            display: flex;
            flex-direction: column;
            width: 480px;
            height: 560px;
            background: #F9F9F9;
            border-radius: 4px;
            padding: 20px 30px 24px;
            box-sizing: border-box;

            .title {
                font-size: 24px;
                line-height: 33px;
                font-weight: bold;
                color: #323B4B;
                margin-bottom: 20px;
            }

            .close {
                position: absolute;
                top: 20px;
                right: 20px;
                display: block;
                width: 20px;
                height: 20px;
                background: url('./assets/delIcon.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                user-select: none;
                cursor: pointer;
            }

            .switch {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-bottom: 18px;

                span {
                    font-size: 14px;
                    line-height: 20px;
                    color: #666666;
                }

                div {
                    display: flex;
                    align-items: center;
                    width: 44px;
                    height: 22px;
                    background: #41B48C;
                    border-radius: 11px;
                    margin-left: 10px;
                    user-select: none;
                    cursor: pointer;

                    &.un {
                        background: #CED3D7;

                        i {
                            margin-left: 2px;
                            transition: margin-left 0.3s;
                        }
                    }

                    i {
                        display: block;
                        width: 18px;
                        height: 18px;
                        background: #FFFFFF;
                        border-radius: 50%;
                        margin-left: 24px;
                        transition: margin-left 0.3s;
                    }
                }
            }

            .input {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;
                height: 40px;
                background: rgba(185, 195, 195, 0.2);
                border-radius: 20px;
                padding: 0 20px;
                box-sizing: border-box;
                margin-bottom: 20px;

                input {
                    flex: 1;
                    height: 100%;
                    background: transparent;

                    &::placeholder {
                        color: #B9C3C3;
                    }
                }

                .search {
                    display: block;
                    width: 16px;
                    height: 16px;
                    background: url('./assets/searchIcon.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-left: 10px;
                }
            }

            .list {
                width: 420px;
                height: 299px;
                background: #EFF0F0;
                border-radius: 4px;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 6px;
                }
                &::-webkit-scrollbar-thumb {
                    background: rgba(185, 195, 195, 0.5);
                    border-radius: 2px;
                }

                &>ul {
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    &>li {
                        display: flex;
                        flex-direction: column;

                        .mainTitle {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: space-between;
                            width: 100%;
                            height: 42px;
                            line-height: 42px;
                            padding: 0 20px;
                            box-sizing: border-box;

                            .left {
                                display: flex;
                                flex-direction: row;
                                align-items: center;

                                i {
                                    display: block;
                                    width: 10px;
                                    height: 10px;
                                    background: url('./assets/arrowIcon.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    margin-right: 12px;

                                    &.on {
                                        transform: rotate(90deg);
                                    }
                                }

                                span {
                                    font-size: 13px;
                                    line-height: 18px;
                                    color: #323B4B;

                                    em {
                                        font-style: normal;
                                    }
                                }
                            }

                            .right {
                                position: relative;
                                width: 16px;
                                height: 16px;
                                border-radius: 8px;
                                border: 1px solid #B9C3C3;
                                box-sizing: border-box;
                                cursor: pointer;

                                &.all {
                                    background: #41B48C;
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;

                                    &::after {
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        margin-left: -6px;
                                        margin-top: -4px;
                                        display: block;
                                        content: '';
                                        width: 12px;
                                        height: 9px;
                                        background: url('./assets/passIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }

                                &.select {
                                    background: #41B48C;
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;

                                    &::after {
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        margin-left: -4px;
                                        margin-top: -1px;
                                        display: block;
                                        content: '';
                                        width: 8px;
                                        height: 2px;
                                        background: url('./assets/waitIcon.png') no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                    }
                                }
                            }
                        }

                        ul {
                            display: flex;
                            flex-direction: column;

                            li {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                align-items: center;
                                width: 100%;
                                height: 42px;       
                                background: rgba(185, 195, 195, 0.15);
                                padding: 0 20px 0 42px;
                                box-sizing: border-box;

                                span {
                                    font-size: 13px;
                                    line-height: 18px;
                                    color: #323B4B;
                                }

                                i {
                                    position: relative;
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    border-radius: 8px;
                                    border: 1px solid #B9C3C3;

                                    &.all {
                                        background: #41B48C;
                                        border: 1px solid #41B48C;
                                        box-sizing: border-box;

                                        &::after {
                                            position: absolute;
                                            top: 50%;
                                            left: 50%;
                                            margin-left: -6px;
                                            margin-top: -4px;
                                            display: block;
                                            content: '';
                                            width: 12px;
                                            height: 9px;
                                            background: url('./assets/passIcon.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                        }
                                    }

                                    &.select {
                                        background: #41B48C;
                                        border: 1px solid #41B48C;
                                        box-sizing: border-box;

                                        &::after {
                                            position: absolute;
                                            top: 50%;
                                            left: 50%;
                                            margin-left: -4px;
                                            margin-top: -1px;
                                            display: block;
                                            content: '';
                                            width: 8px;
                                            height: 2px;
                                            background: url('./assets/waitIcon.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .btns {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-start;
                margin-top: 14px;

                .tips {
                    .selectAll {
                        display: block;
                        width: 14px;
                        height: 14px;
                        border: 1px solid #B9C3C3;
                        box-sizing: border-box;
                        margin-right: 5px;
                        user-select: none;
                        cursor: pointer;

                        &.on {
                            position: relative;
                            background-color: #41B48C;
                            border: 1px solid #41B48C;
                            box-sizing: border-box;

                            &::after {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-left: -6px;
                                margin-top: -4px;
                                display: block;
                                content: '';
                                width: 12px;
                                height: 9px;
                                background: url('./assets/passIcon.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                            }
                        }
                    }

                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    font-size: 12px;
                    line-height: 17px;
                    color: #323B4B;

                    span {
                        color: #829191;
                    }
                }

                .btn {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-top: 10px;

                    p {
                        width: 120px;
                        height: 40px;
                        border-radius: 25px;
                        color: 14px;
                        line-height: 40px;
                        text-align: center;
                        color: #41B48C;
                        border: 1px solid #41B48C;
                        box-sizing: border-box;
                        user-select: none;
                        cursor: pointer;

                        &:nth-last-of-type(1) {
                            margin-left: 20px;
                        }

                        &:nth-of-type(1) {
                            background: #41B48C;
                            color: #FFF;
                        }
                    }
                }
            }
        }
    }
</style>